module.exports = __webpack_public_path__ + "img/kids1.cb2ab7df.jpg";